import { LitElement, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

import componentStyles from './fil-hero-card-group.styles.js';

/**
 * @tag fil-hero-card-group
 * @property {"primary"|"secondary"} [appearance="primary"] Appearance of the component
 */
export class FilHeroCardGroup extends LitElement {
  static properties = {
    appearance: { type: String }, // 'primary' | 'secondary'
  };

  static styles = [componentStyles];

  get slottedChildren() {
    return this.shadowRoot.querySelector('slot').assignedElements({ flatten: true });
  }

  constructor() {
    super();
    this.appearance = 'primary';
  }

  connectedCallback() {
    if (!this.hasAttribute('role')) {
      this.setAttribute('role', 'list');
    }
    super.connectedCallback();
  }

  updated(changedProperties) {
    if (this.slottedChildren.length === 2) {
      this.slottedChildren.forEach(child => {
        child.setAttribute('imagePosition', 'left');
      });
    }
    super.updated(changedProperties);
  }

  render() {
    const classes = {
      [`fil-hero-card-group--${this.appearance}`]: this.appearance !== 'primary',
    };

    return html`<div class="fil-hero-card-group${classMap(classes)}"><slot></slot></div>`;
  }
}

export default FilHeroCardGroup;
